module.exports = __webpack_public_path__ + "img/164.shop.477f8324.svg";